import { escapeHtml } from "@emkit/builder-core";
export const STEPS_DEFAULTS = {
    items: [
        {
            id: "s1",
            title: "Sign up",
            description: "Create a free account — no credit card required.",
        },
        {
            id: "s2",
            title: "Build your page",
            description: "Drag widgets into the canvas and tweak the inspector.",
        },
        {
            id: "s3",
            title: "Ship",
            description: "Export HTML, publish anywhere, done.",
        },
    ],
    layout: "horizontal",
    numbering: "number",
    accent: "#111827",
    textColor: "#0f172a",
    background: "transparent",
    connected: true,
};
export const stepsWidget = {
    type: "steps",
    defaultProps: STEPS_DEFAULTS,
    renderHtml(props) {
        const items = props.items ?? [];
        if (items.length === 0) {
            return `<div class="emk-steps" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty — add steps in the inspector)</div>`;
        }
        const layout = props.layout ?? "horizontal";
        const numbering = props.numbering ?? "number";
        const accent = props.accent ?? "#111827";
        const text = props.textColor ?? "#0f172a";
        const bg = props.background ?? "transparent";
        const connected = props.connected ?? true;
        const renderBadge = (it, i) => {
            if (numbering === "none")
                return "";
            const label = numbering === "icon" && it.icon ? it.icon : String(i + 1);
            return `<div style="flex-shrink:0;width:40px;height:40px;border-radius:50%;background:${accent};color:#fff;display:inline-flex;align-items:center;justify-content:center;font-weight:600;font-size:15px;z-index:1;position:relative">${escapeHtml(label)}</div>`;
        };
        if (layout === "horizontal") {
            const cells = items
                .map((it, i) => {
                const last = i === items.length - 1;
                const connector = connected && !last
                    ? `<div aria-hidden="true" style="flex:1;height:2px;background:${accent};opacity:0.3;margin:0 -2px"></div>`
                    : "";
                const desc = it.description
                    ? `<p style="margin:4px 0 0;font-size:13px;line-height:1.5;color:${text};opacity:0.7">${escapeHtml(it.description)}</p>`
                    : "";
                return `<div style="flex:1;min-width:0;display:flex;flex-direction:column;align-items:center;text-align:center;gap:8px;position:relative">${renderBadge(it, i)}<div><h3 style="margin:0;font-size:15px;font-weight:600;color:${text}">${escapeHtml(it.title)}</h3>${desc}</div></div>${connector}`;
            })
                .join("");
            return `<div class="emk-steps emk-steps--horizontal" style="background:${bg};padding:20px 16px;font-family:inherit"><div style="display:flex;align-items:flex-start;gap:4px;max-width:1200px;margin:0 auto">${cells}</div></div>`;
        }
        // Vertical
        const rows = items
            .map((it, i) => {
            const last = i === items.length - 1;
            const line = connected && !last
                ? `<div aria-hidden="true" style="position:absolute;left:19px;top:40px;bottom:-24px;width:2px;background:${accent};opacity:0.3"></div>`
                : "";
            const desc = it.description
                ? `<p style="margin:4px 0 0;font-size:14px;line-height:1.55;color:${text};opacity:0.7">${escapeHtml(it.description)}</p>`
                : "";
            return `<div style="display:flex;gap:16px;position:relative;padding-bottom:${last ? 0 : 24}px">${line}${renderBadge(it, i)}<div style="flex:1;padding-top:6px"><h3 style="margin:0;font-size:16px;font-weight:600;color:${text}">${escapeHtml(it.title)}</h3>${desc}</div></div>`;
        })
            .join("");
        return `<div class="emk-steps emk-steps--vertical" style="background:${bg};padding:20px 0;font-family:inherit"><div style="max-width:640px;margin:0 auto">${rows}</div></div>`;
    },
};
//# sourceMappingURL=steps.js.map